
if(process.env.NODE_ENV === 'production'){
    console.log("Production environment");
    if(process.env.REACT_APP_ENDPOINT === 'UK')
    {
        console.log("using settings.prod.UK");
        module.exports = require('./settings.prod.UK');
    }
    else if(process.env.REACT_APP_ENDPOINT === 'US')
    {
        console.log("using settings.prod.US");
        module.exports = require('./settings.prod.US');
    }
    else if(process.env.REACT_APP_ENDPOINT === 'QA')
    {
        console.log("using settings.QA");
        module.exports = require('./settings.QA');
    }
}
else{
    console.log("Debug environment");
    if(process.env.REACT_APP_ENDPOINT === 'UK')
    {
        console.log("using settings.dev.UK");
        module.exports = require('./settings.dev.UK');
    }
    else if(process.env.REACT_APP_ENDPOINT === 'US')
    {
        console.log("using settings.dev.US");
        module.exports = require('./settings.dev.US');
    }
    else if(process.env.REACT_APP_ENDPOINT === 'QA')
    {
        console.log("using settings.dev.QA");
        module.exports = require('./settings.dev.QA');
    }
}


// WEBPACK FOOTER //
// ./src/settings/settings.js